import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const STAFF_KEY = "sfap_staff_token";
export const PART_KEY = "sfap_participant_token";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem(STAFF_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e.config?.url || "";
    const onStation = window.location.pathname.startsWith("/station");
    if (e.response?.status === 401 && !url.includes("/auth/login") && !onStation) {
      localStorage.removeItem(STAFF_KEY);
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export const pApi = axios.create({ baseURL: `${API}/public` });
pApi.interceptors.request.use((c) => {
  const t = sessionStorage.getItem(PART_KEY);
  if (t) c.headers["X-Participant-Token"] = t;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "Cannot reach the parish server. Please check your internet connection.";
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export async function download(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const STATUS_LABEL = {
  scheduled: "Scheduled", open: "Open", paused: "Paused", closed: "Closed", finalized: "Finalized",
  pre_registered: "Pre-Registered", pending: "Pending Verification", present: "Present — Verified", late: "Late",
  excused: "Excused", absent: "Absent", disputed: "Disputed", rejected: "Rejected / Invalid",
};

export const fmtTime = (s) =>
  s ? new Date(s).toLocaleString("en-PH", { timeZone: "Asia/Manila", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
export const fmtDate = (d) =>
  d ? new Date(`${d}T00:00:00+08:00`).toLocaleDateString("en-PH", { timeZone: "Asia/Manila", weekday: "short", month: "long", day: "numeric", year: "numeric" }) : "";
export const fmtClock = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
export const manilaToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });
